<template>
  <v-dialog width="400" opacity="0" persistent v-bind="{ ...$props, ...$attrs }">
    <v-card max-width="400" class="pa-8 no-permissions-card">
      <div class="error-icon-container">
        <DpplSvg file-name="error-circle-icon" />
      </div>
      <h3 class="new-h3 no-permissions-title">
        Access Restricted: Permissions Needed
      </h3>
      <p class="new-body-text no-permissions-content">
        It looks like you don't have permission to access the Demographic Survey Report.
      </p>
      <p class="new-body-text no-permissions-content">
        Please reach out to your organization's
        <a href="/app/settings/team/administrators" target="_blank" rel="noopener noreferrer">Datapeople Admin</a>
        if you believe you should have access.
      </p>
      <p class="new-body-text no-permissions-content">
        In the meantime, you may view our
        <b>
          Gender Report.
        </b>
      </p>
      <div class="w-100 d-flex flex-column align-center justify-center mb-2">
        <DpplNewButton
          width="100%"
          color="brandPrimary"
          class="mb-2"
          :to="genderReportRoute"
          @click="trackGenderReportClick"
        >
          Go to the Gender Report
        </DpplNewButton>
        <DpplNewButton
          width="100%"
          color="brandPrimary"
          variant="outlined"
          @click="handleViewDistributionInsights"
        >
          View Distribution Insights Tab
        </DpplNewButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useTracking } from '@/stores/tracking/tracking';

const route = useRoute();

const emit = defineEmits(['update:isSurveyInsightsTab']);

const genderReportRoute = computed(() => {
  const newQuery = { ...(route.query || {}) };

  delete newQuery.tab;
  delete newQuery.country;

  return {
    name: 'gender-report',
    query: newQuery,
  };
});

const trackGenderReportClick = () => {
  useTracking().dsrClickedViewGenderReport({ modal: 'No Permissions' });
};

const handleViewDistributionInsights = () => {
  useTracking().dsrClickedViewData({ tab: 'Distribution Insights', modal: 'No Permissions' });

  emit('update:isSurveyInsightsTab', false);
};
</script>

<style lang="less" scoped>
.no-permissions-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: 8px !important;
}

.error-icon-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: fade(@basic-red, 10%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.no-permissions-title {
  text-align: center;
  color: @text-darkest;
  margin-bottom: 16px;
}

.no-permissions-content {
  color: @text-light;
  margin-bottom: 16px !important;
  text-align: center;
  max-width: 304px;

  a {
    color: @text-brand;
    cursor: pointer;
  }
}
</style>
